/** Page title, loading, refresh and failure language, outside analytical execution bindings. */
export const insightsLoadingCopy = {
    pageTitle: 'Insights',
    loading: 'Loading insights',
    unavailable: 'Insights aren’t ready yet',
    error: 'Insights couldn’t load',
    retry: 'Try again',
    refreshing: 'Updating insights',
    refreshError: 'Insights couldn’t update. Showing the last loaded insights.',
    readiness: {
        not_started: {
            heading: 'Connect your store data to see insights',
            body: 'Your first data sync hasn’t started. Open Settings to check your connection and start a sync.',
        },
        preparing: {
            heading: 'Preparing your insights',
            body: 'Your store data is syncing. This page will check again while the sync is running.',
        },
        blocked: {
            heading: 'Insights are temporarily unavailable',
            body: 'Store data can’t be read right now. Open Settings to check the connection and sync status.',
        },
        failed: {
            heading: 'Your data sync needs attention',
            body: 'The data needed for insights couldn’t finish syncing. Open Settings to review the sync and try again.',
        },
        privacy: 'Store data is unavailable while a privacy request is being processed. Previous insights are hidden.',
        paused: 'Store data is still being prepared. Automatic checks have paused. You can check again or review the sync in Settings.',
        settings: 'Open Settings',
        check: 'Check again',
    },
    loadingCard: (title) => `Loading ${title.toLowerCase()}`,
    loadingTitles: {
        repeatBuying: 'Repeat buying',
        productPairs: 'Products bought together',
        productHistory: 'What customers buy later',
        productMix: 'Product types in paid purchases',
    },
};
//# sourceMappingURL=insights-loading.js.map